// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__S2Uy-","location":"Header_location__37sgd"};